import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=24e84cca&scoped=true&"
import script from "./page-title.vue?vue&type=script&lang=ts&"
export * from "./page-title.vue?vue&type=script&lang=ts&"
import style0 from "./page-title.vue?vue&type=style&index=0&id=24e84cca&lang=less&scoped=true&"
import style1 from "./page-title.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e84cca",
  null
  
)

export default component.exports